import { Component } from '@angular/core';

@Component({
  selector: 'app-disclaimer-create-edit',
  templateUrl: './disclaimer-create-edit.component.html',
})
export class DisclaimerCreateEditComponent {

}
